import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessManagerHandler {
	url: any;
	token: any;
	
	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getBusinessInfo(cb){	
	  	this.url = this.globals.dataUrl + 'business';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	udpateBusiness(params, cb){
	    this.url = this.globals.dataUrl + 'business/' + params.Id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response.Data);
		    }); 
		});             
	}

	updateBusinessImage(params){		
	  	this.url = this.globals.dataUrl + 'business/image';

    	this.storage.get('loginData').then((loginData) => {
    		console.log("||Before post||");

		    this.http.post(
		        this.url,
		        {ImagePath: params.imageString}, 
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => {
		    	console.log("||Mapping||");
		    	console.log("||Status||");
		    	console.log(res.status);
			    // If request fails, throw an Error that will be caught
			    if(res.status < 200 || res.status >= 300) {
			      throw new Error('This request has failed ' + res.status);
			    } 
			    // If everything went fine, return the response
			    else {
			      return res.json();
			    }
			})
		    .subscribe(
				(res) => {
					console.log("Returned data:");
					console.log(res);					
					if(typeof params.cb == "function") params.cb(res.Data);
				}, 
				(err) => {
					console.log("Returned error:");
					console.log(err);
				}
		    );   
    	})
  	}

}



// WEBPACK FOOTER //
// ./src/providers/business-manager-handler.ts